import { SidebarConfig } from "./types"
import { hasAnyRequiredGroup } from "routes/utils"
import { DynamicConfig } from "configuration/config"

export const filterSidebarItems = (
  items: SidebarConfig,
  userGroups: string[],
  config: DynamicConfig
): SidebarConfig => {
  return items
    .filter((item) => {
      if (item.configKey && !config[item.configKey]) {
        return false
      }
      return hasAnyRequiredGroup(userGroups, item.requiredGroups)
    })
    .map((item) => {
      const filteredChildren = (item.children || []).filter((child) => {
        if (child.configKey && !config[child.configKey]) {
          return false
        }
        return hasAnyRequiredGroup(userGroups, child.requiredGroups)
      })

      return {
        ...item,
        children: filteredChildren
      }
    })
}
